import { typingLabel, useTyping } from '../../realtime/typing';

export function TypingIndicator({ channelId }: { channelId: string }) {
  const typists = useTyping(channelId);
  const label = typingLabel(typists.map((t) => t.displayName));
  return (
    <div
      aria-live="polite"
      className="flex h-6 shrink-0 items-center gap-2 px-6 text-xs text-muted"
    >
      {label && (
        <>
          <span className="flex gap-0.5" aria-hidden>
            {[0, 150, 300].map((delay) => (
              <span
                key={delay}
                className="size-1 animate-bounce rounded-full bg-subtle"
                style={{ animationDelay: `${delay}ms` }}
              />
            ))}
          </span>
          {label}
        </>
      )}
    </div>
  );
}
